module.exports = __webpack_public_path__ + "img/icon-contract-eliw.5cb59b09.svg";